import { Users } from 'lucide-react';
import React from 'react';
import styles from '../edit-automation-template/tenant-selection-control/TenantSelectionControl.module.css';

interface SegmentTenantSelectionControlProps {
  onOpen: () => void;
  isDirty?: boolean;
  disabled?: boolean;
}

/**
 * Header trigger that opens the segment tenant-selection dialog. Owns no dialog
 * state — the invoker (EditSegmentPage) owns open/close via useTenantDialog and
 * conditionally mounts SegmentTenantSelectionDialog.
 */
export const SegmentTenantSelectionControl: React.FC<SegmentTenantSelectionControlProps> = ({
  onOpen,
  isDirty = false,
  disabled = false,
}) => {
  return (
    <button
      type="button"
      onClick={onOpen}
      className={`${styles.tenantButton} ${isDirty ? styles.tenantButtonDirty : ''}`}
      disabled={disabled}
      title="Tenant selection"
      aria-label="Tenant selection">
      <Users className={styles.tenantIcon} />
      {isDirty && <span className={styles.dirtyDot} />}
    </button>
  );
};
